<template>

    <layout>
        <TitleLable parentMessage="题库管理"></TitleLable>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="平台题库" name="first">
                <div class="banktitle">
                    <span class="trem" style="font-weight: 700;background: none;color: #000000;">类别</span>
                    <span class="trem" @click="clickBank(0)" :style="bank_index==0?'background-color:#409eff;color:#ffffff':''">阅读在线</span>
                    <span class="trem" @click="clickBank(1)" :style="bank_index==1?'background-color:#409eff;color:#ffffff':''">应试英语</span>
                </div>
                <!-- 阅读在线 -->
                <div v-if="bank_index == 0">
                    <div class="banktitle">
                        <span class="trem" style="font-weight: 700;background: none;color: #000000;">难度</span>
                        <span v-for="(item,index) in grade" :key="index" class="trem" @click="clickGrade(index)" :style="form.grade==index?'background-color:#409eff;color:#ffffff':''">{{ item }}</span>
                    </div>
                    <div v-show="!question_type" class="banktitle">
                        <span class="trem" style="font-weight: 700;background: none;color: #000000;">题型</span>
                        <span v-for="(item,index) in type" :key="index" class="trem" @click="clicktype(index)" :style="form.r_type==index?'background-color:#409eff;color:#ffffff':''">{{ item }}</span>
                    </div>
                    <el-input style="float: left;width: 300px;" size="small" @change="changeKeyword" v-model="form.keyword" @clear="clearKeyword" :clearable="true" placeholder="输入标题搜索"></el-input>
                    
                </div>
                <!-- 应试英语 -->
                <div v-if="bank_index == 1">
                    <div class="banktitle">
                        <span class="trem" style="font-weight: 700;background: none;color: #000000;">难度</span>
                        <span v-for="(item,index) in specialty_grade" :key="index" class="trem" @click="clickSpecialtyGrade(index)" :style="specialty_form.grade==index?'background-color:#409eff;color:#ffffff':''">{{ item }}</span>
                    </div>
                    <div v-show="!question_type" class="banktitle">
                        <span class="trem" style="font-weight: 700;background: none;color: #000000;">题型</span>
                        <span v-for="(item,index) in specialty_type" :key="index" class="trem" @click="clickSpecialtyType(index)" :style="specialty_form.type==index?'background-color:#409eff;color:#ffffff':''">{{ item }}</span>
                    </div>
                    <el-input style="float: left;width: 300px;" size="small" @change="changeKeyword" v-model="specialty_form.keyword" @clear="clearKeyword" :clearable="true" placeholder="输入标题搜索"></el-input>
                </div>
                
                <el-button @click="confirmChange" v-if="question_type" style="float: right;" size="small" class="el-icon-thumb" type="danger"> 确认选择</el-button>
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    highlight-selection-row
                    row-key="id"
                    style="width: 100%;cursor: pointer;margin-top: 20px;display: inline-block;"
                    @selection-change="handleSelectionChange"
                    >
                    <el-table-column
                        :reserve-selection="true"
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        type="index"
                        width="50">
                    </el-table-column>
                    <el-table-column
                        prop="title"
                        label="标题">
                    </el-table-column>
                    <el-table-column
                        prop="number"
                        label="题量"
                        width="150">
                    </el-table-column>
                    <el-table-column width="150" label="操作">
                        <template slot-scope="scope">

                            <el-button
                            size="mini"
                            type="text"
                            @click="handleRowClick(scope.row)">查看</el-button>
                            <el-button
                            size="mini"
                            type="text"
                            v-if="question_type"
                            @click="changeRead(scope.row)">选择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    style="display: inline-block;margin-top: 20px;"
                    v-if="total_number"
                    @size-change="changeSize"
                    @current-change="changeNumber"
                    @prev-click="prev"
                    @next-click="next"
                    :page-size="form.pageSize"
                    :total="total_number">
                </el-pagination>
                <el-dialog :title="`【${read.grade_text}】【${read.label_text}】${ read.title }`" :visible.sync="dialogDetailVisible" @close="readDetailClose">
   
                    <div style="text-align: left;font-size: 15px;line-height: 25px;" v-html="read.body"></div>
                    <div class="readtest">
                        <div style="margin-top: 20px;" v-if="read.answer">参考答案：<div style="margin-top: 10px;" v-html="read.answer"></div> </div>
                        <div v-for="(item,index) in read.test" :key="index">
                            <h4 style="color: #000000;">{{index+1}}. {{ item.question }}( {{ item.r_answer }} )</h4>
                            <div :class="`${bank_index == 1 || read.r_type == 1?(options[qindex] == item.r_answer?'activ':''):pdoptions[qindex] == item.r_answer?'activ':''} question_test`" v-for="(qitem,qindex) in item.answer" :key="qindex" :style="`${!qitem?'display:none':''}`">{{ options[qindex] }}. {{ qitem }}</div>
                            <div class="decipher">答案解析：{{ item.decipher?item.decipher:'暂无解析' }}</div>
                        </div>
                    </div>
       
                </el-dialog>
            </el-tab-pane>
            <el-tab-pane label="自建题库" name="second">
                <el-button type="primary" @click="dialogDirectoryVisible = true" class="el-icon-plus" size="small"> 创建目录</el-button>
                <el-table
                    ref="multipleTable_"
                    :data="directory_data"
                    tooltip-effect="dark"
                    highlight-selection-row
                    row-key="id"
                    style="width: 100%;cursor: pointer;margin-top: 20px;display: inline-block;"
                    @selection-change="handleSelectionChange"
                    >
                    <el-table-column
                        type="index"
                        width="50">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="名称">
                    </el-table-column>
         
                    <el-table-column
                        prop="number"
                        label="数量"
                        width="150">
                    </el-table-column>
                    <el-table-column
                        prop="uname"
                        label="创建人"
                        width="150">
                    </el-table-column>
                    <el-table-column
                        prop="createtime_text"
                        label="时间"
                        width="150">
                    </el-table-column>
                    <el-table-column width="150" label="操作">
                        <template slot-scope="scope">

                            <el-button
                            size="mini"
                            type="text"
                            @click="handleRowClickDirectory(scope.row)">查看</el-button>

                        </template>
                    </el-table-column>
                </el-table>

                <el-dialog title="创建题库目录" :visible.sync="dialogDirectoryVisible" @close="readDirectoryClose">
                    <div class="direc">
                        <el-form ref="form" :model="directory_form" label-width="80px">
                            <el-form-item label="名称">
                                <el-input size="small" v-model="directory_form.name" placeholder="请输入名称"></el-input>
                            </el-form-item>
    
            
                            <el-form-item>
                                <el-button type="primary" size="small" @click="onSubmit">立即创建</el-button>
                                <el-button @click="dialogDirectoryVisible = false" size="small">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                
                </el-dialog>
            </el-tab-pane>
        </el-tabs>
    </layout>

    
</template>
<script>
import TitleLable from '../../units/Titlelabel.vue';
import Http from "../../apis/questionbank";
export default {
    components:{
        TitleLable
    },
    data(){
        return{
            directory_form:{
                name:''
            },
            activeName:'first',
            bank_index:0,
            grade:{1:'一级选文',2:'二级选文',3:'三级选文',4:'四级选文',5:'五级选文',6:'六级选文',7:'七级选文'},
            type:{1:'选择题',2:'判断题',3:'匹配题'},
            options:['A','B','C','D'],
            pdoptions:['T','F'],
            tableData:[],
            form:{
                grade:1,
                r_type:1,
                keyword:'',
                page:1,
                pageSize:20
            },
            total_number:0,
            dialogDetailVisible:false,
            read:{},
            specialty_grade:{},
            specialty_question_type:{},
            specialty_type:{},
            specialty_form:{
                type:1,
                grade:1,
                page:1,
                pageSize:20,
                keyword:''
            },
            question_type:'',
            question_ids:[],
            trem:'',
            directory_data:[],
            dialogDirectoryVisible:false,
            rating:'',  //年级
            type_data:[
                {
                    value:1,
                    name:'单项选择'
                },
                {
                    value:2,
                    name:'阅读理解'
                },
                {
                    value:3,
                    name:'完型填空'
                },
                {
                    value:4,
                    name:'匹配题'
                },
                {
                    value:5,
                    name:'单词变形'
                },
                {
                    value:6,
                    name:'写作题'
                },
                {
                    value:7,
                    name:'翻译题'
                },
                {
                    value:8,
                    name:'听力题'
                },
                {
                    value:9,
                    name:'判断题'
                }
            ],
        }
    },
    created(){
        
        
    },
    activated(){
        
        this.trem = this.$route.query.trem
        this.question_type = this.$route.query.type
 
        this.rating = this.$route.query.grade
        
        this.getSpecialtyQuestion()
        this.getDirectoryData()
    },
    mounted() {
    window.addEventListener('popstate', this.handleBackButton);
  },
    methods:{
        handleBackButton(event) {
            this.$refs.multipleTable.clearSelection()
            // 用户确认离开
            console.log(1)
        },
        changQuestionLabel(){
            if(this.question_type){
                //阅读在线
                if(this.bank_index == 0){
                    var type = 0;
                    switch (this.question_type) {
                        case 2:
                                type = 1
                            break;
                        case 4:
                                type = 3
                            break;
                        case 9:
                                type = 2
                            break;
                    }
                    this.form.r_type = type
                    this.getQuestionbank()
                }else{

                    var row = this.specialty_question_type[this.specialty_form.grade]
                    var str = '';
                    for(var i in this.type_data){
                        if(this.type_data[i].value == this.question_type){
                            str = this.type_data[i].name
                        }
                    }
                    const type = Object.keys(row).find(key => row[key] === str);

                    this.specialty_form.type = type == undefined?0:type
                   
                    this.getspecialtyList()
                }

            }else{
                if(this.bank_index){
                    this.getspecialtyList()
                }else{
                    this.getQuestionbank()
                }
                
            }
        },
        readDirectoryClose(){},
        handleSelectionChange(e){
    
            var row = []
            for(var i in e){
                row.push(e[i].id)
            }
            this.question_ids = row
            if(!this.question_ids.length){
                return false
            }
            var params = {}
            params.type = this.question_type
            params.tabel = this.bank_index
            params.wids = this.question_ids
            Http.verifyQuestion(params).then((res) => {
                if(!res.code){
                    this.$message({
                        message:res.msg,
                        type:'error'
                    })
                }
            });

        },
        confirmChange(){
           
            var question_ids = this.question_ids.join(',')

            localStorage.setItem('question_ids', question_ids);
            this.$refs.multipleTable.clearSelection();
            this.$router.push({ name: 'Createpaper',query:{type:this.question_type,bank_index:this.bank_index,trem:this.trem,grade:this.rating}});
        },

        handleRowClickDirectory(item){
            this.$router.push({ name: 'Questionlist',query:{id:item.id,trem:this.trem,grade:this.rating}});
        },


        // 获取考试题型
        getSpecialtyQuestion(){
            Http.specialtyQuestion().then((res) => {
                this.specialty_grade = res.data.grade
                this.specialty_question_type = res.data.questiontype
                this.specialty_type = res.data.questiontype[1]
                this.changQuestionLabel()
            });
        },

        // 点击应试类别
        clickSpecialtyGrade(index){

            this.specialty_form.grade = index
            this.specialty_form.type = 1
            this.specialty_form.page = 1
            this.specialty_type = this.specialty_question_type[index]

            if(this.question_type){
                this.changQuestionLabel()
            }else{
                this.getspecialtyList()
            }
        },

        // 点击应试题型
        clickSpecialtyType(index){

            this.specialty_form.type = index
            this.getspecialtyList()
        },
        // 获取阅读材料
        getQuestionbank(){
            var data = this.form
            if(localStorage.getItem('change_question_ids')){
                data.wids = localStorage.getItem('change_question_ids');
            }
            Http.Read(this.form).then((res) => {
                
                this.tableData = res.data.data
                this.total_number = res.data.total_number
            });

        },
        readDetailClose(){
            this.dialogFormVisible = true
        },
   
        handleRowClick(row,event){
            this.dialogDetailVisible = true
            var params = {}
            params.id = row.id

            if(this.bank_index == 1){
                params.grade = this.specialty_form.grade
                params.type = this.specialty_form.type
                console.log(params)
                Http.specialtyDetail(params).then((res) => {
                    var data = res.data
                    data.grade_text = this.specialty_grade[this.specialty_form.grade]
                    data.label_text = this.specialty_type[this.specialty_form.type]
                    this.read = res.data
                });
            }else{
                Http.readDetail(params).then((res) => {
                    this.read = res.data
                });
            }
        },

        onSubmit(){
            Http.createDirectory(this.directory_form).then((res) => {
                this.$message({
                    type: res.code?'success':'error',
                    message: '请先设置材料篇数'
                });
                if(res.code){
                    this.dialogDirectoryVisible = false
                    this.getDirectoryData()
                }
            });
        },
        handleClick(tab, event){
            if(tab.index == '1'){
                //this.getDirectoryData()
            }
            
        },
        // 获取题库目录
        getDirectoryData(){
            Http.directory().then((res) => {
                this.directory_data = res.data.data
            });
            
        },
        changeRead(item){
            var question_ids = item.id
            localStorage.setItem('question_ids', question_ids);
      
            this.$router.push({ name: 'Createpaper',query:{type:this.question_type,bank_index:this.bank_index,trem:this.trem,grade:this.rating}});
        },
        
        clickBank(index){
            this.bank_index = index
            
            this.changQuestionLabel()
            if(index == 1){
                this.specialty_form.page = 1
            }else{
                this.form.page = 1
            }
        },
        changeKeyword(){
            if(this.bank_index == 0){
                this.getQuestionbank()
            }else{
                this.getspecialtyList()
            }
        },
        clearKeyword(){
            if(this.bank_index == 0){
                this.getQuestionbank()
            }else{
                this.getspecialtyList()
            }
            
        },
        getspecialtyList(){

            var data = this.specialty_form
       
            if(localStorage.getItem('change_question_ids')){
                data.wids = localStorage.getItem('change_question_ids');
            }

            
            Http.specialtyList(this.specialty_form).then((res) => {
                this.tableData = res.data.data
                this.total_number = res.data.total_number
            });
        },

        clickGrade(index){
            this.form.page = 1
            this.form.grade = index
            this.getQuestionbank()
        },
        clicktype(index){
            this.form.page = 1
            this.form.r_type = index
            this.getQuestionbank()
        },

        // 上一页
        prev(e){
            if(this.bank_index == 0){
                this.form.page = e
                this.getQuestionbank()
            }else{
                this.specialty_form.page = e
                this.getspecialtyList()
            }
            
        },

        // 下一页
        next(e){
            if(this.bank_index == 0){
                this.form.page = e
                this.getQuestionbank()
            }else{
                this.specialty_form.page = e
                this.getspecialtyList()
            }
        },

        // 点击页码
        changeNumber(e){
            if(this.bank_index == 0){
                this.form.page = e
                this.getQuestionbank()
            }else{
                this.specialty_form.page = e
                this.getspecialtyList()
            }
        },

        // 前往指定页数
        changeSize(e){
            if(this.bank_index == 0){
                this.form.page = e
                this.getQuestionbank()
            }else{
                this.specialty_form.page = e
                this.getspecialtyList()
            }
        },
    }
}
</script>
<style lang="less" scoped>
.direc::v-deep .el-radio{
    height: 32px;
}
.direc::v-deep .el-radio-group{
    margin-top: 13px;
}

.banktitle{
    display: inline-block;
    width: 100%;
    margin-top: 15px;
}
.trem{
    color: #409EFF;
    background: #ecf5ff;
    border-color: #b3d8ff;
    padding: 9px 15px;
    font-size: 12px;
    border-radius: 3px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 10px;
}

.question_test{
    width: 80%;
    display: inline-block;
    line-height: 25px;
    box-sizing: border-box;
    color: #409EFF;
    background: #ecf5ff;
    border-color: #b3d8ff;
    padding: 9px 15px;
    font-size: 14px;
    border-radius: 3px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 10px;
}
.activ{
    color: #f56c6c !important;
    background: #fef0f0 !important;
    border-color: #fbc4c4 !important;
    font-weight: 700;
}
.decipher{
    display: inline-block;
    width: 80%;
    line-height: 26px;
    color: #000000;
}
</style>